import { createFileRoute } from '@tanstack/react-router';
import { PartyRedirect } from '@/features/parties/PartyRedirect';

export const Route = createFileRoute('/app/companies_/$companyId')({
  component: CompanyRoute,
  staticData: { title: 'Company' },
});

function CompanyRoute() {
  const { companyId } = Route.useParams();
  return <PartyRedirect key={companyId} kind="company" id={companyId} />;
}
